import Siema from 'siema';

$(document).ready(function(){

    var $slider     = $('.slider');
    var $slideLeft  = $('.button.-slider-left');
    var $slideRight = $('.button.-slider-right');
    var $navButton  = $('button[data-slide]');

    /**
    * Slider Logic
    **/

    if ($('.slider').length) {
        const slider = new Siema({
            selector: '.slider',
            loop: true,
            onChange: () => {
                let slideIndex = slider.currentSlide;

                $navButton.each(function(){
                    let currentButton = parseInt($(this).attr('data-slide'));

                    if (currentButton == slideIndex) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                });
            }
        });  

        $navButton.on('click', function(){
            let slideIndex = parseInt($(this).attr('data-slide'));

            slider.goTo(slideIndex);
        });

        $slideLeft.on('click', function(){
            slider.prev(1);
        });

        $slideRight.on('click', function(){
            slider.next(1);
        });
    }

    if ($('.client-logos').length) {

        var windowWidth = $(window).width();

        if (windowWidth > 800) {
            var slidesPer = 5;
        } else if (windowWidth < 800 && windowWidth > 450) {
            var slidesPer = 3;
        } else {
            var slidesPer = 2;
        }

        const homepageSlider = new Siema({
          selector: '.client-logos',
          duration: 4000,
          loop: true,
          easing: 'linear',
          perPage: slidesPer
        });

        $(window).resize(function(){
            if (windowWidth > 800) {
                slidesPer = 5;
            } else if (windowWidth < 800 && windowWidth > 450) {
                slidesPer = 3;
            } else {
                slidesPer = 2;
            }
        });

        window.setInterval(function(){
            homepageSlider.next(1)
        }, 4000);
    }



});